import ImageComponent from "../ImageComponent";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";
import clsx from "clsx";
import zupeeLogo from "../../assets/zupee-white-logo.svg";
import addMoneyIcon from "../../assets/add-rupee-icon.svg";
import { NAVIGATION_ROUTES } from "../../constant";
import { useUserStore } from "../../storage/userState";
import { formatRupees } from "../../pages/Withdraw/helper";

interface HomeHeaderInterface {
  tournamentsConfig?: any;
}
const HomeHeader: React.FC<HomeHeaderInterface> = ({tournamentsConfig}) => {
  const isWalletEnable = tournamentsConfig?.homeScreenData?.showWallet;
  const zupeeLogoFromApi = tournamentsConfig?.gameDetails[0]?.logoUrl;
  const { userDetails } = useUserStore();
  const winningsBalance = userDetails?.actualCoins;

  return (
    <>
      <div className={clsx(styles.homeHeaderBlock)}>
        <div className={clsx(styles.innerLayer)}>
          <div className={clsx(styles.firstHalf)}>
            <div className={clsx(styles.logoBlock)}>
              <ImageComponent
                src={zupeeLogo}
                // src={zupeeLogoFromApi}
                alt="zupee logo"
                className={clsx(styles.logoStyle)}
                title="Zupee"
              />
            </div>
          </div>
          <div className={clsx(styles.secondHalf)}>
            {isWalletEnable &&
            <>
              <Link
                to={NAVIGATION_ROUTES.WALLET}
                className={clsx(styles.balanceBlock, "fontColorSecondary fontWeightBold fontSizeSm14")}
              >
                {formatRupees(winningsBalance)}
              </Link>
              <Link to="#" className={clsx(styles.addMoneyBlock)}>
                <ImageComponent
                  src={addMoneyIcon}
                  alt="add money icon"
                  className={clsx(styles.addMoneyStyle)}
                  title="add money"
                />
              </Link>
            </>
            }

            {/* TEMPORARY: entry point into the wallet while
                homeScreenData.showWallet is false and the balance chip above
                never renders. Self-removing — the moment showWallet turns on,
                the real chip takes over and this disappears. Delete then.
                Not gated on login: the wallet is viewable logged out, and that
                is where the sign-in flow starts. */}
            {!isWalletEnable && (
              <Link
                to={NAVIGATION_ROUTES.WALLET}
                className={clsx(styles.tempWalletBtn, "fontWeightBold fontSizeSm12")}
              >
                Wallet
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeHeader;